import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 text-background-50 mt-16 md:mt-20">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <h3 className="font-heading text-2xl md:text-3xl font-light text-background-50 tracking-tight">
                关注绿证通
              </h3>
              <p className="text-foreground-400 text-sm mt-3 leading-relaxed">
                扫码添加微信，第一时间获取绿证政策、市场动态与能耗管理干货内容。
              </p>
              <div className="mt-5 flex flex-col items-start">
                <div className="bg-background-50 p-2 rounded-lg">
                  <img src="/images/wecom.png" alt="微信" className="w-32 h-32 object-contain" />
                </div>
                <span className="text-foreground-400 text-sm mt-2">微信</span>
              </div>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-sm font-medium text-background-50 mb-4 font-label">法律声明</h4>
              <div className="flex flex-col gap-2.5">
                {[
                  { label: '免责声明', path: '/agreement/disclaimer' },
                  { label: '用户协议', path: '/agreement/user' },
                  { label: '隐私政策', path: '/agreement/privacy' },
                  { label: '信息发布规范', path: '/agreement/publish' },
                ].map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline cursor-pointer"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div className="md:col-span-4">
              <h4 className="text-sm font-medium text-background-50 mb-4 font-label">联系我们</h4>
              <div className="flex flex-col gap-2.5 text-sm text-foreground-400">
                <p>联系邮箱：info@firmai.cn</p>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs text-center">
              &copy; 2026 上海寻御科技有限公司 · 保留所有权利 | 沪ICP备2026019486号
            </p>
            <div className="flex items-center gap-4">
              <Link to="/agreement/user" className="text-foreground-400 text-xs hover:text-background-50 transition-colors underline cursor-pointer">
                用户协议
              </Link>
              <Link to="/agreement/privacy" className="text-foreground-400 text-xs hover:text-background-50 transition-colors underline cursor-pointer">
                隐私政策
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
